
"use client";

import { AuthProvider } from '@/contexts/AuthContext';
import { SiteStatusProvider } from '@/contexts/SiteStatusContext';
import { InterviewInProgressProvider } from '@/contexts/InterviewInProgressContext';
import { RemoteConfigProvider } from '@/contexts/RemoteConfigContext'; // Import RemoteConfigProvider
import AppContentWrapper from '@/components/layout/AppContentWrapper';
import { Toaster } from "@/components/ui/toaster";
import React from 'react';

export default function ClientProviders({ children }: { children: React.ReactNode }) {
  return (
    <RemoteConfigProvider> {/* RemoteConfigProvider should wrap AuthProvider if Auth depends on it */}
      <AuthProvider>
        <SiteStatusProvider>
          <InterviewInProgressProvider>
            <AppContentWrapper>
              {children}
            </AppContentWrapper>
            <Toaster />
          </InterviewInProgressProvider>
        </SiteStatusProvider>
      </AuthProvider>
    </RemoteConfigProvider>
  );
}
